import Api from '@/common/fetch.js'
import { apiRoute } from '@/common/config'

export default {
    getCompanies (request) {
        return Api.post(apiRoute + '/Company', request)
    },
    getCompany (request) {
        return Api.post(apiRoute + '/Company', request)
    },
    addCompany (request) {
        return Api.post(apiRoute + '/Company', request)
    },
    deleteCompany (request) {
        return Api.post(apiRoute + '/Company', request)
    },

    getCustomers (request) {
        return Api.post(apiRoute + '/Customer', request)
    },
    addCustomer (request) {
        return Api.post(apiRoute + '/Customer', request)
    },
    deleteCustomer (request) {
        return Api.post(apiRoute + '/Customer', request)
    },
    getCustomerGroup () {
        return Api.post(apiRoute + '/CustomerGroup', { Name: "GetItemsList", ItemType: "CustomerGroup", OperatorName: "Admin" })
    },

    getCars (request) {
        return Api.post(apiRoute + '/Car', request)
    },
    deleteCar (request) {
        return Api.post(apiRoute + '/Car', request)
    },

    getCards (request) {
        return Api.post(apiRoute + '/Card', request)
    },
    addCard (request) {
        return Api.post(apiRoute + '/Card', request)
    },
    getCardTypes (request) {
        return Api.post(apiRoute + '/CardTypes', request)
    },

    getTarif () {
        return Api.post(apiRoute + '/Tariff', { Name: "GetItemsList", ItemType: "Tariff", OperatorName: "Admin" })
    },
    getZones1 () {
        return Api.get(apiRoute + '/Zone')
    },
    getZones (request) {
        return Api.post(apiRoute + '/Zone', request)
    },

    getDevices (request) {
        return Api.post(apiRoute + '/Device', request)
    },
    getDevicesTypes (request) {
        return Api.get(apiRoute + '/DeviceType', request)
    },
    setDeviceParam (request) {
        return Api.post(apiRoute + '/SetDeviceParam', request)
    },
    setTabloParam (request) {
        return Api.post(apiRoute + '/setTabloParam', request)
    },
    rebootDevice (request) {
        return Api.post(apiRoute + '/RebootDevice', request)
    },

    getAlarms (request) {
        return Api.post(apiRoute + '/Alarms', request)
    },

    setProperty (request) {
        return Api.post(apiRoute + '/SetProperty', request)
    },

    getAbonements (request) {
        return Api.post(apiRoute + '/getAbonements', request)
    },

    getReports (request) {
        return Api.post(apiRoute + '/getReports/', request)
    },
    getReport (reportName, request) {
        return Api.post(apiRoute + '/getReport/' + reportName, request)
    },
    getReportFiltering (request) {
        return Api.post(apiRoute + '/getReportFiltering/', request)
    },
    getLastEvents (request) {
        return Api.post(apiRoute + '/Events', request)
    },
    confirmEvents (request) {
        return Api.post(apiRoute + '/confirmEvents', request)
    },

    getParkingCards (request) {
        return Api.post(apiRoute + '/getParkingCards', request)
    },
    takeOutCard (request) {
        return Api.post(apiRoute + '/takeOutCard', request)
    },
    blockCard (request) {
        return Api.post(apiRoute + '/blockCard', request)
    },

    editWalletProps (request) {
        return Api.post(apiRoute + '/walletProps', request)
    }
}
